import {
  bigint,
  index,
  integer,
  pgEnum,
  pgTable,
  text,
} from 'drizzle-orm/pg-core'
import {
  getBaseFields,
  getBaseIndexes,
  getIdReference,
  typedJsonb,
} from '../common/utils'
import { users } from './user'

// Bucket enum for public/private file access
export const bucketEnum = pgEnum('bucket', ['public', 'private'])

// Attachments table - polymorphic relationship with any entity
export const attachments = pgTable(
  'attachments',
  {
    ...getBaseFields(),

    // Polymorphic relationship fields
    entityType: text('entity_type').notNull(), // e.g., 'company', 'user', 'project'
    entityId: bigint('entity_id', { mode: 'number' }).notNull(), // ID of the related entity

    // File metadata
    filename: text('filename').notNull(), // Original filename
    filesize: integer('filesize').notNull(), // File size in bytes (client-provided, untrusted - use for display only)
    mimeType: text('mime_type').notNull(), // MIME type

    // Storage information
    storageKey: text('storage_key').notNull(), // Key in cloud storage (not unique - allows copy-by-reference)
    bucket: bucketEnum('bucket').notNull().default('private'), // public or private bucket

    // Optional description
    description: text('description'),

    // Optional metadata for attachment-specific data (e.g., type, order, duration)
    metadata: typedJsonb('metadata'),

    // Upload metadata
    uploadedBy: getIdReference(() => users.id),
  },
  (table) => [
    ...getBaseIndexes('attachments', table),
    // Index for efficient querying by entity
    index('attachments_entity_id_idx').on(table.entityId),
    index('attachments_entity_type_idx').on(table.entityType),
    // Index for storage key lookups
    index('attachments_storage_key_idx').on(table.storageKey),
  ],
)
